import React from "react"
import { useSelector } from "react-redux"
import { getHasDeductible } from "derivedSelectors/deductibleSelectors"
import { getHasCostShare } from "derivedSelectors"
import { Large } from "components/views/atoms/Responsive"
import { Spacer } from "components/views/atoms/Atoms"
import { SideBarBase } from "components/views/atoms/SidebarBase"
import { HowToModule } from "components/views/reimbursements/HowToModule"
import { HowMuchReimbursedModule } from "components/views/reimbursements/educationmodal/HowMuchReimbursedModule"
import { ConnectInsuranceInfoModule } from "../ConnectInsuranceInfoModule"
import { useToggle } from "../../../../utils/Hooks"
import { BenefitEnrollmentFlowContainer } from "components/csd-enrollment"
import { useConnectInsurance } from "../../../context/enrollment/ConnectInsuranceContext"

const UploadSidebar = ({ expenseId }) => {
  const hasDeductible = useSelector(getHasDeductible)
  const hasCostShare = useSelector(getHasCostShare)
  const { showOptionalInsuranceInfoPromo } = useConnectInsurance()
  const displayReimbursement = hasDeductible || hasCostShare

  const [showBenefitEnrollmentModal, toggleBenefitEnrollmentModal] = useToggle(false)
  return (
    <>
      {expenseId && (
        <Large>
          <Spacer height={4} />
        </Large>
      )}
      <SideBarBase>
        <HowToModule />
        {displayReimbursement && <HowMuchReimbursedModule />}
        {showOptionalInsuranceInfoPromo && <ConnectInsuranceInfoModule onClickEnroll={toggleBenefitEnrollmentModal} />}
      </SideBarBase>
      {showBenefitEnrollmentModal && <BenefitEnrollmentFlowContainer onExit={toggleBenefitEnrollmentModal} />}
    </>
  )
}

export { UploadSidebar }
